import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { AdminService } from '../../services/admin.service';
import { AuthService } from 'src/app/auth-module/services/auth.service';

@Component({
  selector: 'app-facility-info-left-panel',
  templateUrl: './facility-info-left-panel.component.html',
  styleUrls: ['./facility-info-left-panel.component.scss']
})
export class FacilityInfoLeftPanelComponent implements OnInit, OnChanges {
  @Input() facilityInfo;
  // @Output() isDisableForm = new EventEmitter();
  value = 0;
  color = 'accent'
  isDisable: boolean = true;
  showIcon: boolean = true;
  lastUpdatedAt;
  created_at: string;
  facility_name: any;
  userId;

  constructor(private adminService: AuthService) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('SimpleChanges in facility info left panel', changes);

    if (changes?.facilityInfo?.currentValue) {
      this.facility_name = changes?.facilityInfo?.currentValue?.facility_name;
      this.lastUpdatedAt = moment(changes?.facilityInfo.currentValue?.updated_at).format("MMM DD YYYY");
      this.created_at = moment(changes?.facilityInfo.currentValue?.created_at).format("MMM DD YYYY");
      this.userId = changes.facilityInfo.currentValue.id;
      this.profilePercentageCall();
    }
  }

  profilePercentageCall() {
    this.adminService.profileCompletion(this.userId, sessionStorage.getItem("token")).subscribe((response: any) => {
      this.value = response.data?.profile_percentage;
      console.log(response.data?.profile_percentage);
    })
  }

  editClicked() {
    // this.isDisable = !this.isDisable;
    // this.isDisableForm.emit(this.isDisable);
    // this.showIcon = false;
  }
}
